// src/activities/cape-vr/cape-vr-views/cape-vr-files/cape-vr-form-files/AdditionalFeaturesEvaluation.jsx

import { useFixedTForResource } from '../../../../../locales/useFixedTForResource';
import { variableTranslations } from '../../../../../constants/variableTranslations';

function AdditionalFeaturesEvaluation({
  selectedAdditionalFeatures,
  setSelectedAdditionalFeatures,
  additionalFeaturesValues,
  setAdditionalFeaturesValues,
}) {
  const t = useFixedTForResource('CAPEVR');

  const handleCheckboxChange = (feature) => {
    if (selectedAdditionalFeatures.includes(feature)) {
      setSelectedAdditionalFeatures(
        selectedAdditionalFeatures.filter((item) => item !== feature)
      );
      const updatedValues = { ...additionalFeaturesValues };
      delete updatedValues[feature];
      setAdditionalFeaturesValues(updatedValues);
    } else {
      const translationKey = variableTranslations[feature] || feature;
      const attributeName = feature === 'otherAdditionalFeature'
        ? additionalFeaturesValues?.otherAdditionalFeature?.attributeName || ''
        : t(translationKey);
      setSelectedAdditionalFeatures([...selectedAdditionalFeatures, feature]);
      setAdditionalFeaturesValues({
        ...additionalFeaturesValues,
        [feature]: {
          attributeName,
        },
      });
    }
  };

  const handleTextChange = (e) => {
    const newText = e.target.value;
    const hasText = newText.trim() !== '';
    setSelectedAdditionalFeatures(current => hasText
      ? current.includes('otherAdditionalFeature') ? current : [...current, 'otherAdditionalFeature']
      : current.filter(item => item !== 'otherAdditionalFeature'));
    setAdditionalFeaturesValues({
      ...additionalFeaturesValues,
      otherAdditionalFeature: {
        ...additionalFeaturesValues.otherAdditionalFeature,
        attributeName: newText,
      },
    });
  };

  return (
    <div className="capevr-radio-group">
      <label className="capevr-radio-label">{t('additional_features')}:</label>
      <div className="capevr-checkboxes-horizontal">
        {[
          'aphonia',
          'asthenia',
          'diplophonia',
          'falsetto',
          'fry',
          'hardGlottalAttack',
          'wetGurgly',
          'otherAdditionalFeature',
        ].map((value) => {
          const translationKey = variableTranslations[value] || value;
          return (
            <label key={value} className="capevr-checkbox-label-inline">
              <input
                type="checkbox"
                name={value}
                value={value}
                checked={selectedAdditionalFeatures.includes(value)}
                onChange={() => handleCheckboxChange(value)}
              />
              {t(translationKey)}
              {value === 'otherAdditionalFeature' && (
                  <input
                    type="text"
                    id="otherAdditionalFeatureTag"
                    value={additionalFeaturesValues?.otherAdditionalFeature?.attributeName || ''}
                    onChange={handleTextChange}
                    placeholder={t('specify')}
                    aria-label={t('other_additional_feature')}
                    className="app-input capevr-input-inline"
                  />
                )}
            </label>
          );
        })}
      </div>
    </div>
  );
}

export default AdditionalFeaturesEvaluation;
